import { useCallback, useRef } from 'react'

export const useHideButtonDownLoad = () => {
  const refDownloadButton = useRef(null)
  const handleHideButtonDownload = useCallback(
    (hide?: boolean) => {
      const currentDisplay = refDownloadButton.current?.style?.display

      if (hide && currentDisplay === 'flex' && refDownloadButton.current) {
        refDownloadButton.current.style.display = 'none'
      }

      if (!hide && (!currentDisplay || currentDisplay === 'none') && refDownloadButton.current) {
        refDownloadButton.current.style.display = 'flex'
      }
    },
    [refDownloadButton],
  )

  return {
    refDownloadButton,
    handleHideButtonDownload,
  }
}
